<app-dynamic-form
    (formValuesChanged)="search($event)"
    [submit]="false"
    [reset]="false"
    [formCols]="12"
    [formFields]="searchInputs"
/>
